export default __webpack_public_path__ + "static/spotify-colored-6c34cc0fb9b451148d1644a8f90ab4c4.svg";